<h2 mat-dialog-title>{{'Speed trial result' | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <h3>{{'Crew number'}}</h3>
    <form [formGroup]="speedTrialResultGroup">
        <div>
            <mat-form-field appearance="fill" class="inputs first-two">
                <mat-label>{{'Minutes' | translate}}</mat-label>
                <input matInput placeholder="Minutes" formControlName="minutes" [disabled]="!isOrganizer" required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="inputs first-two">
                <mat-label>{{'Seconds' | translate}}</mat-label>
                <input matInput placeholder="Seconds" formControlName="seconds" [disabled]="!isOrganizer" required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="inputs">
                <mat-label>{{'Milliseconds' | translate}}</mat-label>
                <input matInput placeholder="Milliseconds" formControlName="milliseconds" [disabled]="!isOrganizer" required>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="fill" class="bad-points-input">
                <mat-label>{{'Number of bad points' | translate}}</mat-label>
                <input matInput placeholder="Number of bad points" formControlName="points" [disabled]="!isOrganizer" required>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{'Cancel' | translate}}</button>
    <button mat-button [disabled]="speedTrialResultGroup.invalid || !isOrganizer" (click)="updateSpeedTrial()">{{'Update speed trial' | translate}}</button>
</mat-dialog-actions>
